import React from 'react';
import { MyGoals } from './pages/MyGoals';
export function App() {
  return <MyGoals data-id="element-0" />;
}